// extracted by mini-css-extract-plugin
module.exports = {"textarea":"style_textarea__2mLIJ","textareaError":"style_textareaError__3tzcX","submitButton":"style_submitButton__29LUH","textAreaError":"style_textAreaError__GgFly"};